// CANONICAL COPY (GH #7115). src/constants/obligations/obl-data-masking.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-data-masking',
  title: 'Verify data masking and segmentation controls',
  description:
    'Confirm that data masking, pseudonymisation or anonymisation techniques are applied in accordance with the access control policy, business requirements and applicable legislation. Data processing and storage shall be segmented based on sensitivity so that higher-sensitivity data is processed and stored only in appropriately controlled environments.',
  category: 'technical',
  scfIds: ['SCF-DAT-004'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    {
      type: 'document-published',
      description: 'Data masking / segmentation procedure is published',
    },
    { type: 'document-within-sla', description: 'Procedure review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
